module.exports = __webpack_public_path__ + "static/media/arrow-down.de05411d.svg";